"use client"

import type React from "react"
import { FaTimes, FaWhatsapp, FaMoneyBillWave, FaUniversity, FaArrowRight } from "react-icons/fa"

interface PaymentMethodsModalProps {
  isOpen: boolean
  onClose: () => void
  manualPaymentConfirmed?: boolean
  onDirect?: () => void
}

const PaymentMethodsModal: React.FC<PaymentMethodsModalProps> = ({
  isOpen,
  onClose,
  manualPaymentConfirmed = false,
  onDirect,
}) => {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden transform transition-all"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-[#2d53da] p-6 relative">
          <button
            className="absolute top-4 right-4 text-white hover:bg-white/20 rounded-full p-1 transition-colors"
            onClick={onClose}
          >
            <FaTimes className="text-xl" />
          </button>
          <h2 className="text-2xl font-bold text-white">Métodos de Pago Manual</h2>
          <div className="w-16 h-1 bg-white/50 rounded-full mt-2"></div>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-700 mb-6">Puedes realizar el pago mediante transferencia a una de estas cuentas:</p>

          {/* Payment Methods */}
          <div className="space-y-4 mb-6">
            <div className="flex items-center p-4 bg-blue-50 rounded-xl border border-blue-100 transition-all hover:shadow-md">
              <div className="bg-[#2d53da] p-3 rounded-lg mr-4">
                <FaMoneyBillWave className="text-white text-xl" />
              </div>
              <div>
                <span className="block font-semibold text-gray-800">Nequi</span>
                <span className="block font-semibold text-gray-800">Jared Foster</span>
                <span className="text-gray-600">320 253 5923</span>
              </div>
            </div>

            <div className="flex items-center p-4 bg-blue-50 rounded-xl border border-blue-100 transition-all hover:shadow-md">
              <div className="bg-[#2d53da] p-3 rounded-lg mr-4">
                <FaUniversity className="text-white text-xl" />
              </div>
              <div>
                <span className="block font-semibold text-gray-800">Bancolombia</span>
                <span className="block font-semibold text-gray-800">Cuenta de Ahorros</span>
                <span className="text-gray-600">358-000068-63</span>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-lg mb-6">
            <p className="text-sm text-yellow-700">
              Una vez realizada la transferencia, envía el comprobante al siguiente número de WhatsApp para activar tu
              suscripción.
            </p>
          </div>

          {/* WhatsApp Button */}
          <a
            href="https://wa.me/573502103574?text=Hola,%20he%20realizado%20el%20pago%20de%20mi%20suscripci%C3%B3n%20y%20quisiera%20solicitar%20su%20activaci%C3%B3n.%20%C2%A1Muchas%20gracias!"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full"
          >
            <button className="flex items-center justify-center w-full bg-green-500 hover:bg-green-600 text-white py-3 px-4 rounded-xl font-medium transition-colors">
              <FaWhatsapp className="mr-2 text-xl" /> Contactar por WhatsApp
            </button>
          </a>

          {/* Direct Button - Only shown when payment is confirmed */}
          {manualPaymentConfirmed && onDirect && (
            <button
              onClick={onDirect}
              className="flex items-center justify-center w-full bg-[#2d53da] hover:bg-[#1e3eb8] text-white py-3 px-4 rounded-xl font-medium mt-4 transition-colors"
            >
              Dirigirse al Dashboard <FaArrowRight className="ml-2" />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default PaymentMethodsModal

